define('controllers/viewmemberenrollmentsteps',['require'],function(require) {
    return function() {
        $("#stepsList li span.btn").on("click", function () {
            var content = $(this).next();
            content.css("display") == 'none' ? content.fadeIn('slow') : content.fadeOut('fast');
        });

        $("#stepsList li button").on("click", function () {
            var $this = $(this),
                stepId = $this.val(),
                commonIssues = $this.prev().val(),
                infoMsg = $this.next(".alert-info"),
                errorMsg = $this.nextUntil(".alert-error").next();

            $this.prop('disabled', true);
            infoMsg.hide();
            errorMsg.hide();

            $.ajax({
                type: 'POST',
                url: "updateEnrollmentStepAJAX.aspx",
                data: { stepId: stepId, CommonIssues: commonIssues },
                success: function (response) {
                    if (response.indexOf("Successfully") != -1) {
                        infoMsg.text(response).show();
                    } else {
                        errorMsg.text(response).show();
                    }
                    $this.prop('disabled', false);
                },
                error: function () {
                    errorMsg.text("Something went wrong. Please re-load the page and try again or contact Adestinn Support.").show();
                    $this.prop('disabled', false);
                }
            });
        });
    };
});

